import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";

@Component({
    selector: "app-paste-page-modal",
    templateUrl: "./paste-page-section-modal.component.html",
    styleUrls: ["./paste-page-section-modal.component.scss"],
    standalone: false
})
export class PastePageSectionModalComponent {
  onclose = new Subject();
  onsubmit = new Subject();

  copiedItem: ICopiedItem;

  includeResources: boolean = false;
  includeLanguages: boolean = false;

  onClose() {
    this.onclose.next(true);
  }

  onSubmit() {
    this.onsubmit.next({
      includeLanguages: this.includeLanguages,
      includeResources: this.includeResources,
    });
  }
  ngOnInit() {
    this.includeResources = !!this.copiedItem.numberOfResources;
    this.includeLanguages = !!this.copiedItem.numberOfLanguages;
  }
}

interface ICopiedItem {
  numberOfLanguages: number;
  numberOfResources: number;
  title: string;
  exists: boolean;
}
